import type { ReactNode } from "react";
import { BreakpointContext } from "./context";
import type { Breakpoint } from "./types";

interface BreakpointProviderProps {
  breakpoint: Breakpoint;
  children: ReactNode;
}

/**
 * Overrides the detected breakpoint for all useBreakpoint() calls in descendants.
 * Useful for preview contexts where the container size differs from viewport.
 */
export function BreakpointProvider({ breakpoint, children }: BreakpointProviderProps) {
  return <BreakpointContext.Provider value={breakpoint}>{children}</BreakpointContext.Provider>;
}
